/**
 * donthuocquocgia.vn (National Electronic Prescription System) client — ADR-0019.
 * Pro-entitlement-gated server-side (HTTP 402 on Lite). Submission is signature-
 * pending until platform-signing lands; the manual XML export is the usable path.
 */
import { apiClient } from "./client";

export interface GovRxStatus {
  prescriptionId: string;
  versionNumber: number;
  naturalKey: string;
  status:
    | "NOT_SUBMITTED"
    | "EXPORTED_MANUAL"
    | "SUBMITTING"
    | "ACCEPTED"
    | "REJECTED"
    | "FAILED";
  nationalTxId: string | null;
  nationalStatus: string | null;
  errorCode: string | null;
  errorDetail: string | null;
  payloadSigned: boolean;
  apiProvisioned: boolean;
  attemptCount: number;
  submittedAt: string | null;
  updatedAt: string | null;
}

export interface GovRxSubmitResult {
  status: string;
  accepted: boolean;
  fellBackToManual: boolean;
  message: string;
}

export const GOV_RX_STATUS_LABEL: Record<string, string> = {
  NOT_SUBMITTED: "Chưa gửi",
  EXPORTED_MANUAL: "Đã xuất XML (nộp thủ công)",
  SUBMITTING: "Đang gửi",
  ACCEPTED: "Đã được tiếp nhận",
  REJECTED: "Bị từ chối",
  FAILED: "Lỗi gửi",
};

export const govRxApi = {
  status(prescriptionId: string): Promise<GovRxStatus> {
    return apiClient
      .get<GovRxStatus>(`/v1/prescriptions/${prescriptionId}/gov-rx`)
      .then((r) => r.data);
  },
  submit(prescriptionId: string): Promise<GovRxSubmitResult> {
    return apiClient
      .post<GovRxSubmitResult>(
        `/v1/prescriptions/${prescriptionId}/gov-rx/submit`
      )
      .then((r) => r.data);
  },
  reconcile(prescriptionId: string): Promise<GovRxStatus> {
    return apiClient
      .post<GovRxStatus>(
        `/v1/prescriptions/${prescriptionId}/gov-rx/reconcile`
      )
      .then((r) => r.data);
  },
  /** Download the national-format XML as a file. */
  async downloadExport(prescriptionId: string): Promise<void> {
    const res = await apiClient.get(
      `/v1/prescriptions/${prescriptionId}/gov-rx/export.xml`,
      { responseType: "blob" }
    );
    const url = URL.createObjectURL(res.data as Blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `don-thuoc-quoc-gia-${prescriptionId}.xml`;
    a.click();
    URL.revokeObjectURL(url);
  },
};

export const govRxQueryKeys = {
  status: (id: string) => ["gov-rx", id] as const,
};
